import axios from "axios";
import CustomInterceptors from "@/api/GAInterceptors";

const instanceUserManagement = axios.create({
  baseURL: process.env.VUE_APP_USERMANAGEMENT_API
});

instanceUserManagement.interceptors.request.use(CustomInterceptors.GAInterceptors);

instanceUserManagement.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default instanceUserManagement;